import React from 'react';
import { Property } from 'csstype';

interface IFullColorProps {
    children?: React.ReactNode;
    onTop?: boolean,
    position?: Property.Position,
    blur?: boolean
}

export const FullColor: React.FC<IFullColorProps> = ({ onTop = false, children, position = "fixed", blur = false}) => {
    return <div className={`full-color full-color__${position} ${blur && 'full-color__blur'} ${onTop && 'full-color-on-top'}`}>{children}</div>;
};
